import { Navigate, type RouteObject } from 'react-router-dom'
import { DashboardPage } from './DashboardPage'
import { NewPartnerPage } from './NewPartnerPage'
import { VerifyPage } from './VerifyPage'
import { TeamPage } from './TeamPage'
import { RulesPage } from './RulesPage'
import { BillingPage } from './BillingPage'
import { BillsPage } from './BillsPage'
import { ReviewPage } from './ReviewPage'
import { InviteAcceptPage } from './InviteAcceptPage'
import { ProfilePage } from './ProfilePage'
import { ButtonPage } from './ButtonPage'

export const routes: RouteObject[] = [
  { path: '/partner', element: <DashboardPage /> },
  { path: '/partner/new', element: <NewPartnerPage /> },
  { path: '/partner/verify', element: <VerifyPage /> },
  { path: '/partner/team', element: <TeamPage /> },
  { path: '/partner/rules', element: <RulesPage /> },
  { path: '/partner/points', element: <RulesPage /> },
  // CHANGE-007 #5: no customers page for partners; customers join by signing in with their billing email
  { path: '/partner/customers', element: <Navigate to="/partner" replace /> },
  { path: '/partner/billing', element: <BillingPage /> },
  { path: '/partner/bills', element: <BillsPage /> },
  { path: '/partner/review', element: <ReviewPage /> },
  { path: '/partner/profile', element: <ProfilePage /> },
  { path: '/partner/button', element: <ButtonPage /> },
  { path: '/partner-invite/:token', element: <InviteAcceptPage /> },
]
